import api from "../../utils/apiUserCliente";

export const getPerfilCliente = async () => {
  const res = await api.get("/api/cliente/checkout/perfil");
  return res.data;
};

export const getDireccionesCliente = async () => {
  const res = await api.get("/api/cliente/checkout/direcciones");
  const body = res.data;
  if (body && Array.isArray(body.data)) return body.data;
  if (Array.isArray(body)) return body;
  return [];
};
